import { __decorate, __extends } from "tslib";
import { index, Model, primary } from '@tencent/memoire-structured-storage';
var BlobBaseModel = /** @class */ (function (_super) {
    __extends(BlobBaseModel, _super);
    function BlobBaseModel(_a) {
        var path = _a.path, type = _a.type, namespace = _a.namespace;
        var _this = _super.call(this) || this;
        _this.path = path;
        _this.type = type;
        _this.namespace = namespace;
        return _this;
    }
    __decorate([
        primary()
    ], BlobBaseModel.prototype, "path", void 0);
    __decorate([
        index()
    ], BlobBaseModel.prototype, "type", void 0);
    __decorate([
        index()
    ], BlobBaseModel.prototype, "namespace", void 0);
    return BlobBaseModel;
}(Model));
export default BlobBaseModel;
//# sourceMappingURL=blob-base-model.js.map